module.exports = __webpack_public_path__ + "static/media/izlozba (16).95d16d4a.jpg";